export default function parse(input) {
  let pos = 0;
  let charsUsed = 0;

  function nextChar() {
    return input[pos];
  }

  function consumeChar() {

    let char = input[pos++] || "";
    if( !['{','}','^','_'].includes(char) ){

      console.log({charsUsed,char})
      charsUsed++;

    }
    
    
    return char;

  }

  function parseUntil(stopChars) {
    const result = [];
    let posAtInit = charsUsed;
    while (pos < input.length && !stopChars.includes(nextChar())) {
      if (nextChar() === '^' || nextChar() === '_') {
        result.push(parseModifier());
      } else if (nextChar() === '{') {
        result.push(parseGroup());
      } else {
        result.push({
          text:parseText(),
          index:posAtInit,
        });
      }
    }
    return result;
  }

  function parseText() {
    let text = '';
    while (pos < input.length && !['^', '_', '{', '}'].includes(nextChar())) {
      text += consumeChar();
    }
    return text;
  }

  function parseGroup() {
    if (nextChar() !== '{') throw new Error("Expected '{'");
    consumeChar(); // skip '{'
    const group = [];

    while (pos < input.length && nextChar() !== '}') {
      const char = nextChar();
      if (char === '^' || char === '_') {
        group.push(parseModifier());
      } else if (char === '{') {
        group.push(parseGroup());
      } else {
        let text = parseText();
        group.push({
          index:charsUsed,
          text
        });
        /*
        group.push({
          index:charsUsed,
          parseText()
        });
        */
      }
    }

    consumeChar(); // skip '}'

    // flatten one layer if group is just a single string
    return group.length === 1 ? group[0] : group;
  }

  function parseModifier() {
    const mod = consumeChar(); // '^' or '_'
    const kind = mod === '^' ? 'sup' : 'sub';

    let posAtInit = charsUsed;

    let value;
    if (nextChar() === '{') {

      //posAtInit = pos+1;
      value = parseGroup();

      
    } else {
      value = consumeChar();
    }

    return {
      [kind]: Array.isArray(value) ? value : [value],
      index:posAtInit,
    };
  }

  function parseBaseline() {
    return parseUntil([]);
  }

  return parseBaseline();
}



let input = "x_{n+1} hello world^{+/-_{below}} ";
input = "x^{y}x^{yx}x^z";
console.log(JSON.stringify(parse(input),null,1));
